import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import SplashScreen from '../components/SplashScreen';
import LandingPage from '../pages/LandingPage';

const RootRoute = () => {
  const { loading, isAuthenticated } = useContext(AuthContext);

  if (loading) return <SplashScreen />;
  if (isAuthenticated()) return <Navigate to="/today" replace />;
  return <LandingPage />;
};

export default RootRoute;
